/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* =====================================================================
   BUY 2 GET 1 FREE - "you are 1 item away" cart nudge
   Added 05 Sep 2026.

   What this does
   --------------
   Counts how many vitamins/supplements are in the basket and shows a
   progress message inside the cart drawer (the panel that slides out)
   and on the cart page. It updates itself whenever the basket changes.

   To change the offer, edit the CONFIG block below.
   To switch the whole thing off, set ENABLED to false.
   ===================================================================== */
(function () {
  'use strict';

  /* ---------------- CONFIG - safe to edit ---------------- */
  var ENABLED    = true;
  var COLLECTION = 'dog-supplements-vitamins';  // which collection counts
  var GOAL       = 3;                            // items needed (buy 2 get 1 = 3)
  var LINK       = '/collections/dog-supplements-vitamins';
  var CTA_TEXT   = 'Add another supplement';

  /* Backup list, used only if the collection cannot be read from the
     storefront (e.g. it is unpublished). Product IDs as of 05 Sep 2026.
     You normally do not need to touch this. */
  var FALLBACK_IDS = [
    15326057300346,  // Prenatal Chews
    15332811080058,  // Calming Treats
    15326201971066,  // Probiotic Chews
    15326077321594,  // 8-in-1 Multivitamin Chews
    15326084661626   // Active Hip & Joint Chews
  ];

  function messageFor(remaining) {
    if (remaining <= 0) {
      return 'Your free item is in the basket. Enjoy!';
    }
    if (remaining === 1) {
      return 'You are <strong>1 item away</strong> from a free one. Add one more supplement and the cheapest of the three costs you nothing.';
    }
    return 'Add ' + remaining + ' more supplements and the cheapest of the three is free.';
  }
  /* ------------------ end of CONFIG ---------------------- */

  if (!ENABLED || !window.fetch) { return; }

  var qualifyingIds = null;   // product IDs in the promo collection
  var writing = false;        // guards against reacting to our own DOM edits
  var pending = null;

  /* Look up which products are in the promo collection. Done once, then
     cached. Using the live collection means adding a new supplement to
     the collection automatically includes it - no code change needed. */
  function loadQualifyingIds() {
    if (qualifyingIds) { return Promise.resolve(qualifyingIds); }
    return fetch('/collections/' + COLLECTION + '/products.json?limit=250', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (data) {
        qualifyingIds = (data.products || []).map(function (p) { return p.id; });
        if (!qualifyingIds.length) { qualifyingIds = FALLBACK_IDS.slice(); }
        return qualifyingIds;
      })
      .catch(function () { qualifyingIds = FALLBACK_IDS.slice(); return qualifyingIds; });
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .catch(function () { return { items: [] }; });
  }

  function countQualifying(cart, ids) {
    var total = 0;
    (cart.items || []).forEach(function (item) {
      if (ids.indexOf(item.product_id) !== -1) { total += item.quantity; }
    });
    return total;
  }

  function ensureStyles() {
    if (document.getElementById('cs-nudge-styles')) { return; }
    var css = ''
      + '.cs-nudge{max-width:1200px;margin:16px auto;padding:16px 20px;border:2px solid #FF6128;border-radius:12px;background:#FFF6F2;box-sizing:border-box}'
      + '.cs-nudge *{box-sizing:border-box}'
      + '.cs-nudge__msg{margin:0 0 12px;font-size:15px;line-height:1.5;color:#7A2A0C}'
      + '.cs-nudge__msg strong{color:#B8330D}'
      + '.cs-nudge__track{height:8px;border-radius:99px;background:#F5D9CD;overflow:hidden;margin:0 0 12px}'
      + '.cs-nudge__fill{display:block;height:100%;border-radius:99px;background:linear-gradient(90deg,#FF6128,#E0431A);transition:width .35s ease}'
      + '.cs-nudge__cta{display:inline-block;background:#FF6128;color:#fff !important;text-decoration:none !important;font-weight:700;font-size:14px;padding:11px 20px;border-radius:8px}'
      + '.cs-nudge__cta:hover{background:#E0431A;color:#fff !important}'
      + '.cs-nudge--close{border-color:#E0431A;background:#FFEFE7}'
      + '.cs-nudge--done{border-color:#1E8E4A;background:#EFF9F2}'
      + '.cs-nudge--done .cs-nudge__msg{color:#14602F}'
      + '.cs-nudge--done .cs-nudge__fill{background:linear-gradient(90deg,#25A557,#1E8E4A)}'
      + '.cs-nudge--compact{margin:0 0 14px;padding:12px 14px;border-radius:10px}'
      + '.cs-nudge--compact .cs-nudge__msg{font-size:13px;margin-bottom:9px}'
      + '.cs-nudge--compact .cs-nudge__track{height:6px;margin-bottom:9px}'
      + '.cs-nudge--compact .cs-nudge__cta{display:block;text-align:center;font-size:13px;padding:9px 14px}'
      + '@media (max-width:749px){.cs-nudge{margin:12px 16px;padding:14px 16px}'
      + '.cs-nudge__msg{font-size:14px}'
      + '.cs-nudge__cta{width:100%;text-align:center;padding:13px 20px}'
      + '.cs-nudge--compact{margin:0 0 12px;padding:11px 13px}'
      + '.cs-nudge--compact .cs-nudge__msg{font-size:13px;line-height:1.45;margin-bottom:8px}'
      + '.cs-nudge--compact .cs-nudge__track{height:6px;margin-bottom:8px}'
      + '.cs-nudge--compact .cs-nudge__cta{padding:11px 14px;font-size:13px}}'
      + '@media (prefers-reduced-motion:reduce){.cs-nudge__fill{transition:none}}';
    var tag = document.createElement('style');
    tag.id = 'cs-nudge-styles';
    tag.appendChild(document.createTextNode(css));
    document.head.appendChild(tag);
  }

  function buildNode(compact) {
    var el = document.createElement('div');
    el.className = 'cs-nudge' + (compact ? ' cs-nudge--compact' : '');
    el.setAttribute('data-cs-nudge', '');
    el.innerHTML =
        '<p class="cs-nudge__msg" data-cs-msg></p>'
      + '<div class="cs-nudge__track"><span class="cs-nudge__fill" data-cs-fill style="width:0%"></span></div>'
      + '<a class="cs-nudge__cta" data-cs-cta href="' + LINK + '">' + CTA_TEXT + '</a>';
    return el;
  }

  function paint(el, count) {
    var remaining = Math.max(GOAL - count, 0);
    var filled    = Math.min(count, GOAL);
    var pct       = Math.round((filled / GOAL) * 100);

    el.classList.toggle('cs-nudge--done', remaining === 0);
    el.classList.toggle('cs-nudge--close', remaining === 1);

    var msg = el.querySelector('[data-cs-msg]');
    if (msg) { msg.innerHTML = messageFor(remaining); }

    var fill = el.querySelector('[data-cs-fill]');
    if (fill) { fill.style.width = pct + '%'; }

    var cta = el.querySelector('[data-cs-cta]');
    if (cta) { cta.style.display = remaining === 0 ? 'none' : ''; }

    el.style.display = count > 0 ? '' : 'none';
  }

  function update() {
    Promise.all([loadQualifyingIds(), getCart()]).then(function (results) {
      var ids   = results[0];
      var cart  = results[1];
      var count = countQualifying(cart, ids);

      ensureStyles();
      writing = true;

      /* Update anything already on the page (e.g. the cart page block). */
      var existing = document.querySelectorAll('[data-cs-nudge]');
      for (var i = 0; i < existing.length; i++) { paint(existing[i], count); }

      /* Make sure every cart drawer has one too. Themes can render more
         than one cart container (for example a separate one for small
         screens), so we handle all of them rather than just the first. */
      var drawers = document.querySelectorAll('#mini-cart .mini-cart__content, .mini-cart__content');
      for (var j = 0; j < drawers.length; j++) {
        if (!drawers[j].querySelector('[data-cs-nudge]')) {
          var node = buildNode(true);
          drawers[j].insertBefore(node, drawers[j].firstChild);
          paint(node, count);
        }
      }

      setTimeout(function () { writing = false; }, 0);
    });
  }

  function schedule() {
    clearTimeout(pending);
    pending = setTimeout(update, 120);
  }

  /* The theme's own documented events. */
  document.addEventListener('product:added', schedule);
  document.addEventListener('cart:refresh', schedule);
  document.documentElement.addEventListener('product:added', schedule);
  document.documentElement.addEventListener('cart:refresh', schedule);

  /* Safety net: catch any basket change the events miss. */
  if (window.fetch) {
    var originalFetch = window.fetch;
    window.fetch = function () {
      var url = arguments[0];
      var href = (typeof url === 'string') ? url : (url && url.url) || '';
      return originalFetch.apply(this, arguments).then(function (response) {
        if (/\/cart\/(add|change|update|clear)/.test(href)) { schedule(); }
        return response;
      });
    };
  }

  /* Watch the drawer itself - it is re-rendered when the basket changes. */
  function watchDrawer() {
    if (!window.MutationObserver) { return; }

    var drawer = document.getElementById('mini-cart');
    if (drawer) {
      new MutationObserver(function () {
        if (!writing) { schedule(); }
      }).observe(drawer, { childList: true, subtree: true });
      return;
    }

    /* Not built yet - some layouts add the drawer later. Wait for it. */
    var waiting = new MutationObserver(function () {
      if (document.getElementById('mini-cart')) {
        waiting.disconnect();
        watchDrawer();
        schedule();
      }
    });
    waiting.observe(document.body, { childList: true, subtree: true });
  }

  function boot() { watchDrawer(); update(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
